// extracted by mini-css-extract-plugin
export default {"tabPage":"CardsBasedTabPage_tabPage__pY8jb"};